export default {
  onlyOneTip: '同个场景内仅支持添加1个轮播组件。',
  direction: {
    vertical: '垂直',
    horizontal: '水平',
    label: '排列方式',
  },
  displayNum: {
    label: '坑位数',
    title: '轮播组',
    desc: '最中间为坑位1，如坑位数量为5，则从左到右坑位数对应分别为4、5、1、2、3',
  },
  carouselSetting: '轮播设置',
  carouselType: {
    normal: '常规轮播',
    pulseScale: '原地缩放轮播',
    rollScale: '滚动缩放轮播',
    opacity: '透明度轮播',
    opacityScale: '渐隐缩放轮播',
  },
  playMode: {
    auto: '自动',
    manual: '手动',
    title: '播放设置',
  },
  triggerMode: {
    click: '点击',
    drag: '拖拽',
    title: '交互方式',
  },
  condition: {
    switchDone: {
      label: '切换轮播时',
      tip: '轮播完成停住时，触发响应事件。',
    },
    resourceSwitchDone: {
      label: '轮播到某一资源',
      tip: '特定资源轮播完成停住时，触发响应事件。',
    },
    tagSwitchDone: {
      label: '轮播到某一类别的资源',
      tip: '轮播到某一类别的资源',
    },
  },
  component: {
    title: '轮播组件',
    libTitle: '轮播',
    add: {
      tips: '每个场景只能添加一个轮播组件',
    },
    stayTime: {
      label: '动画停留时间',
    },
    animationDuration: {
      label: '动画播放时长',
    },
    displaySize: '坑位尺寸',
    displaySpace: '坑位间隔',
    style: {
      title: '轮播样式选择',
      selectTips: '样式选择',
    },
    group: {
      title: '资源组',
      add: '添加轮播组',
    },
    pite: {
      setting: {
        title: '坑位设置',
      },
      switch: {
        tips: '禁用后，轮播组下无法进行轮播，且轮播组内事件效果失效',
      },
    },
    method: {
      title: '交互方式',
    },
    extraSetting: {
      title: '高级设置',
    },
    mask: {
      title: '超出范围是否裁剪',
      scale: '裁剪',
      notScale: '不裁剪',
    },
    resource: {
      title: '资源',
    },
    groupPreview: {
      title: {
        on: '关闭预览',
        off: '预览尺寸',
      },
    },
    scale: {
      title: '坑位缩放',
    },
  },
  tagManage: {
    title: '资源类别',
    tabTitle: '资源类别',
    select: {
      tips: '选择类别',
    },
    desc: '资源类别用于事件判定成功or失败时机',
    add: {
      label: '添加类别',
    },
    delete: {
      tips: '该类别已应用在轮播组资源中，确定要删除吗？',
    },
    tag: {
      name: {
        label: '名称',
      },
    },
  },
}
